import React, { Component } from "react";
import {
  FaExclamationCircle as Warning,
} from "react-icons/fa";
import "./index.css";

export default class ModuleCard extends Component {
  render() {
    let icon
    if (this.props.module.lastResult && this.props.module.lastResult !== "0001-01-01T00:00:00+00:00") {
      switch (this.props.module.lastResultStatus) {
        case "error":
        case "warning":
          icon = <Warning className="dark-red bg-white br4 icon" size="0.8em" />;
          break;
        case "success":
        default:
          icon = null
      }
    }

    let bg = (
      this.props.module.status === 'warning'
        ? 'bg-yellow'
        : this.props.module.status === 'unhealthy'
          ? 'bg-red warning-bg'
          : this.props.module.status === 'stopped'
            ? 'bg-blue'
            : 'bg-green'
    )

    const href = (
      "/healthcheck/results?module=" +
      this.props.module.name +
      "&environment=" +
      this.props.environment
    )

    return (
      <a
        className={`${bg} b--black-10 white pointer w-100 pa1 card module-card link center ba shadow-5 br2 pv2 pl2 pl0-ns tc-m tc-l center-m h-100 flex justify-center items-center`}
        href={href}
      >
        <h2 className="mv0 f4 f2-l fw5 truncate">
          {icon} {this.props.module.name}
        </h2>
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Healthcheck/ModuleCard/index.js